import Grievance from "../../../jsx/components/Dashboard/Grievance/grievance";

const GrievanceWrapper = () => {
  return <Grievance />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(GrievanceWrapper);
